namespace $.$$ {

	export class $shm_service_task_list extends $.$shm_service_task_list {

		task_title_rows( id: string ) {
			const markers = this.task_marker_rows( id )
			return [
				...( markers.length ? [ this.Task_markers( id ) ] : [] ),
				this.Task_title( id ),
			]
		}

	}

}
